;(function (document) {
  var HIDE_COOKIE_PROMPT_CLASS = 'cookie_consent--hidden';

  var cookieConsentButton = document.getElementById('cookie-consent-btn');

  cookieConsentButton.addEventListener('click', function() {
    createCookie('cookie_consent_agreed', 'true', 30);

    var cookiePrompt = document.getElementById('cookie-consent');
    cookiePrompt.classList.add(HIDE_COOKIE_PROMPT_CLASS);
  });

  var hasUserAgreedToCookies = readCookie('cookie_consent_agreed');

  if (!hasUserAgreedToCookies) {
    // Show cookie prompt
    var cookiePrompt = document.getElementById('cookie-consent');
    cookiePrompt.classList.remove(HIDE_COOKIE_PROMPT_CLASS);
  }
})(document)

